import React from "react"
import "./Spinner.scss"

function Spinner({ small }) {
  return (
    <div className={small ? "spinner-container-small" : "spinner-container-full"}>
      <div className="spinner spinner-5"></div>
    </div>
  )
}

export default Spinner
